import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from "@mui/material";
import React, { useState } from "react";
import {
  AssignableUser,
  SiteVisitAssignee,
  Venue,
} from "./venues-widget.types";

interface AssignModalProps {
  open: boolean;
  venue: Venue | null;
  user: AssignableUser | null;
  alreadyAssigned: SiteVisitAssignee[];
  onClose: () => void;
  onConfirm: (date: string) => Promise<void>;
}

const AssignModal: React.FC<AssignModalProps> = ({
  open,
  venue,
  onClose,
  onConfirm,
}) => {
  const [date, setDate] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    if (!date) return;
    setSubmitting(true);
    setError(null);
    try {
      await onConfirm(date);
      setDate("");
    } catch {
      setError("Failed to schedule site visit. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setDate("");
    setError(null);
    onClose();
  };
  

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>
        Schedule Site Visit
      </DialogTitle>

      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {venue && (
          <Box
            sx={{
              p: 1.5,
              mb: 2,
              borderRadius: 2,
              bgcolor: "action.hover",
              display: "flex",
              flexDirection: "column",
              gap: 0.5,
            }}
          >
            <Typography fontWeight={600} fontSize="0.9rem">
              {venue.name}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {venue.address_one || "No address"}
            </Typography>
          </Box>
        )}
        {/* {alreadyAssigned.length > 0 && (
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mb: 0.5, display: "block" }}
            >
              Already assigned
            </Typography>
            <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
              {alreadyAssigned.map((u) => (
                <Chip
                  key={u.id}
                  avatar={
                    <Avatar src={user?.profile_picture_url ?? undefined}>
                      {u.first_name?.[0]}
                    </Avatar>
                  }
                  label={`${u.first_name} ${u.last_name}`.trim()}
                  size="small"
                />
              ))}
            </Box>
          </Box>
        )}

        {user && (
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mb: 0.5, display: "block" }}
            >
              Adding
            </Typography>
            <Chip
              avatar={<Avatar>{user.first_name?.[0]}</Avatar>}
              label={`${user.first_name} ${user.last_name}`.trim()}
              size="small"
              color="primary"
            />
          </Box>
        )} */}

        <TextField
          label="Scheduled Date"
          type="date"
          fullWidth
          size="small"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: new Date().toISOString().split("T")[0] }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} color="inherit" disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!date || submitting}
        >
          {submitting ? (
            <CircularProgress size={18} color="inherit" />
          ) : (
            "Confirm"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignModal;
